function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Cultivation'))  {
    return [
    {
      title: 'Cultivation',
      icon: 'mdi-shovel',
      items: [
        {title: 'Products', icon: 'mdi-nutrition', path: '/culProducts'},
        {title: 'Inventory', icon: 'mdi-package-variant', path: '/culInventory'},
        {title: 'Bins', icon: 'mdi-basket', path: '/culBins'},
        {title: 'Mothers', icon: 'mdi-mother-nurse', path: '/CulMoms'},
        {title: 'Clones', icon: 'mdi-dna', path: '/CulClones'},
        {title: 'Plantings', icon: 'mdi-sprout', path: '/CulPlantings'},
        {title: 'Plants', icon: 'mdi-cannabis', path: '/culPlants'},
        {title: 'Harvest', icon: 'mdi-tractor', path: '/CulHarvest'},
        {title: 'Process', icon: 'mdi-debug-step-over', path: '/CulProcess'},
        {title: 'Trim', icon: 'mdi-content-cut', path: '/culTrim'},
        {title: 'Reports', icon: 'mdi-file-document-outline', path: '/culReports'},
        {title: 'Waste', icon: 'mdi-trash-can-outline', path: '/culWaste'}
      ]
    }
  ] } else return []
}

export default buildMenu